mainApp.component('discoveryProgressBar', {
    templateUrl: '/public/components/discovery/discovery-progress-bar.component.html',
    bindings: {
        totalCount: '<',
        selectedFields: '<',
        disableExport: '=',
        fromTime: '<',
        toTime: '<',
        filters: '<',
        sort: '<',
        fieldsCardinality: '<',
        progressId: '=',
        progress: '=',
        cancelExport: '=',
        startProgress: '&'
    },
    controller: ['ProgressBarService', '$state', '$sce', '$scope', function(ProgressBarService, $state, $sce, $scope)
    {
        const MAX_NUM_EXPORT_EVENTS = 250000;
        var ctrl = this;

        ctrl.$onInit = function(){
            ctrl.exportFileName = "";
        }

        ctrl.shouldDisableExport = function(){
            return ctrl.disableExport || ctrl.totalCount == 0;
        }
         ctrl.closeNamePopup = function(){
                    $scope.$root.closePopup('enterFileName');
        }
        ctrl.selectedFieldsExist = function (){
            return !angular.equals(ctrl.selectedFields, ['time', 'event_data']);
        }
        ctrl.getExportMessage = function (){
            var totalCountDisplay = parseFloat(ctrl.totalCount).toLocaleString('en')
            if(ctrl.totalCount <= MAX_NUM_EXPORT_EVENTS){
                var message = totalCountDisplay + ' events are ready to export.';
            }
            else{
                var message = '';
                if (isSystemLogin) {
                    message = '<p style="font-weight:bold">Note: Non-system users can only export up to 250,000 events at one time.</p>';
                    message += 'You are trying to export ' + totalCountDisplay + ' events. </br>Select ‘Export all events’ to export all the ' + totalCountDisplay + ' events.';
                }
                else {
                    message += 'You are trying to export ' + totalCountDisplay +
                    ' events which exceeds the limit.</br>Only 250,000 events will be exported.';
                }
            }
            return $sce.trustAsHtml(message);
        }

        ctrl.getDateAndSuffix = function() {
            return '_' + ctrl.exportTime + '.csv';
        }

        ctrl.shouldShowCheckbox = function(){
            return isSystemLogin && ctrl.totalCount > MAX_NUM_EXPORT_EVENTS;
        }

        ctrl.exportCsv = function(exportOption) {
            ctrl.exportOption = exportOption;
            ctrl.exportFileName = 'CatoEventsDiscoveryExport';
            ctrl.exportTime = moment().format('YYYY-MM-D-HH-mm-ss');
            $scope.$root.openPopup('enterFileName');
        }

        ctrl.export = function(){
            let fileNameWithSuffix = ctrl.exportFileName + ctrl.getDateAndSuffix();
            var discoveryConfig = {
                fileName: fileNameWithSuffix,
                exportAll: ctrl.allEvents,
                fromTime: ctrl.fromTime,
                toTime: ctrl.toTime,
                filters: ctrl.filters,
                sort: ctrl.sortFields || [],
                selectedFields: ctrl.selectedFields,
                fieldsCardinality: ctrl.fieldsCardinality,
            }
            if(ctrl.exportOption == 'allFields'){
                discoveryConfig.sort = [];
                discoveryConfig.selectedFields = [];
            }
            ctrl.exportData(discoveryConfig);
            ctrl.closeNamePopup();
        }

        ctrl.openExportOptions = function(){
            if($('#sortedOrAll').css('display') === 'block'){
                $scope.$root.closePopup("sortedOrAll");
            }
            else{
                 $scope.$root.openPopup("sortedOrAll");
            }
        }

        ctrl.exportData = function(discoveryConfig) {
            store.fetch({
                method: 'POST',
                path: '/discoverData/events/export',
                queryParams: {accountId: $state.params.accountId},
                data: discoveryConfig,
                dataObj: 'discoveryConfig',
                success: function(data) {
                    $scope.$root.handleServerResponse(data, "", "");
                    if(data.status == 'ERROR'){
                        ctrl.cancelExport = false;
                        return;
                    }
                    ctrl.startProgress({progress: data});
                    ProgressBarService.progress = data;
                }
             });
         }

        ctrl.redirectTo = function (path) {
            window.location=path + "&accountId=" + $state.params.accountId;
        }

        ctrl.progressFinish = function(data) {
            ctrl.cancelExport = false;
            if (data && data.redirectTo){
                ctrl.redirectTo(data.redirectTo);
                ctrl.progress.message = "Export complete";
            }
            ctrl.progressId = null;
            ProgressBarService.progress = null;
        };

        ctrl.cancelRunningExport = function() {
            $scope.$root.confirm("Are you sure you want to cancel the event export?", function () {
                store.fetch({
                    method: 'POST',
                    path: '/discoverData/events/cancelExport',
                    queryParams: { id: ctrl.progressId, accountId: $state.params.accountId},
                    success: function(data) {
                    }
                }, 'Yes', 'No', null, null, null, null);
                ctrl.cancelExport = false;
                ctrl.progressId = null;
                ProgressBarService.progress = null
            });
        }

        $scope.$on('$reset-popup-params', ()  => {
            ctrl.progressId = null;
        });
    }]
});
